<template>
  <div class="client" data-testid="client-file">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between">
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <router-link class="nav-link" :to="{ name: 'ClientVisit'}" v-if="$route.name !== 'ClientVisit'" data-testid="client-tab-visits"><i class="fa fa-calendar-o fa-lg" aria-hidden="true"></i> Návštěvy</router-link>
                <span class="nav-link active" v-else="" data-testid="client-tab-visits"><i class="fa fa-calendar-o fa-lg" aria-hidden="true"></i> Návštěvy</span>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{ name: 'ClientAnamnesis'}" v-if="$route.name !== 'ClientAnamnesis'" data-testid="client-tab-anamnesis"><i class="fa fa-notes-medical fa-lg" aria-hidden="true"></i> Anamnéza</router-link>
                <span class="nav-link active" v-else="" data-testid="client-tab-anamnesis"><i class="fa fa-notes-medical fa-lg" aria-hidden="true"></i> Anamnéza</span>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{ name: 'ClientMedicament'}" v-if="$route.name !== 'ClientMedicament'" data-testid="client-tab-medicaments"><i class="fa fa-adjust fa-lg" aria-hidden="true"></i> Léky a recepty</router-link>
                <span class="nav-link active" v-else="" data-testid="client-tab-medicaments"><i class="fa fa-adjust fa-lg" aria-hidden="true"></i> Léky a recepty</span>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{ name: 'ClientMedicalReport'}" v-if="$route.name !== 'ClientMedicalReport'" data-testid="client-tab-medical-reports"><i class="fa fa-pencil-square-o fa-lg" aria-hidden="true"></i> Lékařské zprávy</router-link>
                <span class="nav-link active" v-else="" data-testid="client-tab-medical-reports"><i class="fa fa-pencil-square-o fa-lg" aria-hidden="true"></i> Lékařské zprávy</span>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{ name: 'ClientResult'}" v-if="$route.name !== 'ClientResult'" data-testid="client-tab-results"><i class="fa fa-flask fa-lg" aria-hidden="true"></i> Laboratorní výsledky</router-link>
                <span class="nav-link active" v-else="" data-testid="client-tab-results"><i class="fa fa-flask fa-lg" aria-hidden="true"></i> Laboratorní výsledky</span>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{ name: 'ClientTask'}" v-if="$route.name !== 'ClientTask'" data-testid="client-tab-tasks"><i class="fa fa-check-square-o fa-lg" aria-hidden="true"></i> Úkoly</router-link>
                <span class="nav-link active" v-else="" data-testid="client-tab-tasks"><i class="fa fa-check-square-o fa-lg" aria-hidden="true"></i> Úkoly</span>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{ name: 'ClientDocument'}" v-if="$route.name !== 'ClientDocument'" data-testid="client-tab-document"><i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i> Dokumenty</router-link>
                <span class="nav-link active" v-else="" data-testid="client-tab-document"><i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i> Dokumenty</span>
              </li>
            </ul>
          </div>
          <router-view></router-view>
        </div>
      </div>


      <!--<div class="col-md-10">
        <client-visits :do-update="reloadClientVisits" v-on:updated="updateClientVisitsDone"></client-visits>
        <div class="card">
          <div class="card-header">
            Lékařské zprávy
          </div>
          <div class="card-body">
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="card">
          <div class="card-header">
            Akce
          </div>
          <div class="card-body">
            <button class="btn btn-sm btn-primary" @click="showModalClientVisitAdd"><i class="fa fa-calendar-plus-o" aria-hidden="true"></i> naplánovat návštěvu</button>
          </div>
        </div>
      </div>
    </div>
     <client-insurance :client-birth-date="client.birth_date" v-if="client"></client-insurance>-->
  </div>
    <!--<client-visit-add :opened="modalAddVisitOpened" v-on:update="updateClientVisits"></client-visit-add>-->
  </div>
</template>

<script>
  // import auth from '../../auth'
  // import error from '../../error'

  // import ClientVisits from './components/ClientVisits.vue'
  // import ClientInsurance from './components/ClientInsurance.vue'
  import ClientVisitAdd from './modals/AddVisit.vue'
  // import AddVisit from './components/AddVisit.vue'

  // import { mapState, mapActions } from 'vuex'

  export default {
    data () {
      return {
        modalAddVisitOpened: false
      }
    },
    components: {
      ClientVisitAdd
    },
    // computed: mapState({
    // client: state => state.client,
    // clientPending: state => state.pending.client,
    // clientError: state => state.error.client
    // }),
    methods: {
      // ...mapActions(['getClient']),
      /* getClient (clientId) {
        this.clientPending = true
        this.$http.get(this.setting.hostname + 'client/' + clientId).then(response => {
          this.client = response.data
          this.clientPending = false
        }, response => {
          this.clientError = response.body.error
          this.clientPending = false
        })
      }, */
      showModalClientVisitAdd () {
        this.modalAddVisitOpened = true
        this.showModal('client-visit-add')
      },
      showModal (name) {
        this.$modal.show(name)
      },
      customLabel ({ code, name }) {
        return `${code} – ${name}`
      },
      updateClientVisits () {
        this.modalAddVisitOpened = false
        this.reloadClientVisits = true
      },
      updateClientVisitsDone () {
        this.reloadClientVisits = false
      }
    },
    beforeMount () {
      // this.getClient({params: {id: this.$route.params.clientid}})
      // this.getClient(this.$route.params.clientid)
      /* var startDate = this.$moment().subtract(1, 'year').dayOfYear(1)
      for (var i = 0; i < 6; i++) {
        this.possibleDates.push(startDate.add(6, 'months').format('L'))
      }
      var td = new Date()
      this.today = Date(td.getFullYear(), td.getMonth(), 0) */
    },
    watch: {
      selectedInsuranceCompany: function () {
        this.newInsurance.insurance_company_code = this.selectedInsuranceCompany.code
      },
      '$route' () {
        this.$forceUpdate()
        // this.getClient(this.$route.params.clientid)
        this.updateClientVisits()
      }
    },
    created () {
      //
    }

  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.input-group.input-group-unstyled input.form-control {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.input-group-unstyled .input-group-addon {
  border-radius: 4px;
  border: 0px;
  background-color: transparent;
}
.row_description {
}
.row_description > td {
  padding-bottom: 1px;
  border: none;
  font-size: smaller;
}
.row_data {
}
.row_data > td {
  padding-top: 0px;
  font-weight: bold;
  font-size: large;
  border: none;
}

.width_fix {
  width: 100%;
}
.label_like {
  max-width: 100%;
  /*font-weight: bold;*/
}
.main_attribute {
  max-width: 100%;
  font-size: x-large;
  font-weight: bold;
}

.custom_panel_heading {
  border-bottom: none;
  padding-bottom: 0;
  background-color: #b5e3cf;
}

.custom_panel_heading .nav-tabs {
  border-bottom: none;
}

.custom_panel_heading .nav-tabs > li > a {
  background-color: #fff;
}

.custom_panel_heading .nav-tabs > li:nth-child(odd) {
  margin-right: 0;
}

.custom_panel_heading .nav-tabs > li:nth-child(even) {
  margin-left: 0;
}

  /*modal insurance*/

  tr.valid_line {
    font-weight: bold;
  }

  table.table td {
      padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/Client/ShowClient.vue?78c392b6